import type { CardProps } from 'antd';
import { Skeleton } from 'antd';
import React from 'react';
import styles from './index.module.less';

// 普通信息分区复用标准标题和加载反馈；独立业务对象继续使用 Card。
export default function PageSection({
  title,
  extra,
  children,
  className,
  style,
  loading,
  contentStyle,
}: React.PropsWithChildren<
  Pick<
    CardProps,
    | 'title'
    | 'extra'
    | 'className'
    | 'style'
    | 'loading'
    | 'size'
    | 'type'
    | 'bordered'
    | 'variant'
  > & { contentStyle?: React.CSSProperties }
>) {
  return React.createElement(
    'section',
    {
      className: [styles.section, className].filter(Boolean).join(' '),
      style,
      'aria-busy': loading || undefined,
    },
    (title || extra) &&
      React.createElement(
        'div',
        { className: styles.header },
        title && React.createElement('h2', { className: styles.title }, title),
        extra,
      ),
    React.createElement(
      'div',
      { className: styles.content, style: contentStyle },
      loading ? React.createElement(Skeleton, { active: true }) : children,
    ),
  );
}
